import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
`;

export const OrderViewContainer = styled.div`
  padding-bottom: 24px;
`;
